module.exports = __webpack_public_path__ + "school/img/shexinjiazhiguan.61ebe220.png";